import React from "react";
import {
  Datagrid,
  List,
  TextField,
  UrlField,
  useLocaleState,
} from "react-admin";

const SocialsList = () => {
  const [locale] = useLocaleState();

  return (
    <List pagination={false}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField label="socials.title" source={`title.${locale}`} />
        <UrlField label="socials.link" source="link" />
      </Datagrid>
    </List>
  );
};

export default SocialsList;
